'use client';
import * as React from 'react';
import { useTheme } from 'next-themes';

export function useDarkMode() {
  const { theme, setTheme, resolvedTheme, systemTheme } = useTheme();
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => setMounted(true), []);

  // Remove unnecessary type assertion
  const current: string | undefined = resolvedTheme ?? theme ?? systemTheme;
  const isDarkMode = (current ?? 'light') === 'dark';

  const toggleDarkMode = () => setTheme(isDarkMode ? 'light' : 'dark');

  return {
    isDarkMode,
    toggleDarkMode,
    setDarkMode: (v: boolean) => setTheme(v ? 'dark' : 'light'),
    theme: current,
    mounted
  };
}